export const reportColumnsDefinitions = [
    {
        label: 'Date',
        field: 'date',
        classes: 'date-column',
        fixable: true,
        sort: false,
    },
    {
        label: 'Target $',
        field: 'target',
        sort: false,
        fixable: true
    },
    /*{
        label: 'Target125 $',
        field: 'target125',
        sort: false,
        fixable: true,
    },
    {
        label: 'Target150 $',
        field: 'target150',
        sort: false,
        fixable: true,
    },*/
    {
        label: 'Estimate $',
        field: 'actual',
        sort: false,
        fixable: true,
    },
    {
        label: 'Difference $',
        field: 'difference',
        sort: false,
        fixable: true,
        meta: {
            attributes : {
                classes: ['yahoo-arbitrage-difference']
            }
        }
    }
]


// WEBPACK FOOTER //
// ./src/configs/target/overpayment.js